import React, { createContext, useContext, useState } from "react";
import { ActionItem, ContentState, ContentSubstate } from "../../models/SKArtifact";

// Define the context type
interface UpdateListContextType {
  updateList: (contentId: string, status: ContentState | undefined, subStatus: ContentSubstate) => void;
  // deleteIten: (contentId: string) => void;
  // addIten: (contentId: string) => void;
  setUpdateContentListFunction: React.Dispatch<
    React.SetStateAction<(channelId: string, staus: ContentState | undefined, subStatus: ContentSubstate) => void>
  >;
}

// Create the context with a default value of `null`
const UpdateListContext = createContext<UpdateListContextType | null>(null);

// Hook to access the context
export const useUpdateList = (): UpdateListContextType => {
  const context = useContext(UpdateListContext);
  if (!context) {
    throw new Error("useUpdateList must be used within an UpdateListProvider");
  }
  return context;
};

// Provider component to wrap the app
export const UpdateListProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  // State to hold the updateList function
  const [updateList, setUpdateContentListFunction] = useState<
    (contentId: string, staus: ContentState | undefined, subStatus: ContentSubstate) => void
  >(() => () => {});

  return <UpdateListContext.Provider value={{ updateList, setUpdateContentListFunction }}>{children}</UpdateListContext.Provider>;
};
